import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  setToken,
  setMisc,
  setLang,
  setBrightcoveAccountId,
  setTotalQuestions,
  setPassPercent
} from "../../../localstorage-service";
import {
  getMisc,
  getToken,
  verifyEmail,
  getConstants
} from "../../../data-service";
import Spinner from "../../User/Common/Spinner/Spinner";
import {
  validateEmail,
  emptyCheck,
  getParameterByName
} from "../../../utilities";

class LoginContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      errorMessage: "",
      email: "",
      password: "",
      showSpinner: false,
      successMessage: ""
    };
  }

  validate(email, password) {
    if (emptyCheck(email)) {
      this.setState({ error: true, errorMessage: "Please enter your email" });
      this.focusElement("inputEmail");
      return false;
    } else if (emptyCheck(password)) {
      this.setState({ error: true, errorMessage: "Please enter password" });
      this.focusElement("inputPassword");
      return false;
    } else if (!validateEmail(email)) {
      this.setState({
        error: true,
        errorMessage: "Please enter a valid email address"
      });
      this.focusElement("inputEmail");
      return false;
    } else {
      this.setState({ error: false, errorMessage: "" });
      return true;
    }
  }

  getConstantsFromService() {
    getConstants().then(response => {
      setBrightcoveAccountId(response.data[0].Value);
      setTotalQuestions(response.data[2].Value);
      setPassPercent(response.data[3].Value);
    });
  }

  componentDidMount() {
    // console.log(this.props.match);
    const paramId = getParameterByName("id", window.location.href);
    try {
      if (paramId) {
        this.setState({ showSpinner: true, error: false });
        verifyEmail(paramId)
          .then(response => {
            this.setState({
              showSpinner: false,
              error: false,
              successMessage: "Your email is verified now. You can now login"
            });
            // console.log(response);
          })
          .catch(error => {
            if (error.response.data.ModelState) {
              this.setState({
                showSpinner: false,
                error: true,
                errorMessage: error.response.data.ModelState[""].join(",")
              });
            }
          });
      }
    } catch (e) {}
  }

  getsetMiscStorage() {
    getMisc().then(response => {
      setMisc(JSON.stringify(response.data));
      this.props.history.push("/");
    });
  }

  focusElement(name) {
    this.refs[name].focus();
  }

  handleSubmit = () => {
    const email = this.refs["inputEmail"].value;
    const password = this.refs["inputPassword"].value;
    if (this.validate(email, password)) {
      this.setState({ showSpinner: true, error: false });
      getToken(this.state.email, this.state.password)
        .then(response => {
          this.setState({ showSpinner: false });
          setToken(response.data.access_token);
          setLang(response.data.language);
          this.getConstantsFromService();
          this.getsetMiscStorage();
        })
        .catch(error => {
          this.setState({
            showSpinner: false,
            error: true,
            errorMessage:
              error.request.response === ""
                ? "Request was made but no response received. Please try after sometime or contact administrator"
                : error.response.data.error_description
          });
          // console.log(error);
        });
    }
  };
  handleEmailChange = event => {
    this.setState({ email: event.target.value });
  };

  handlePasswordChange = event => {
    this.setState({ password: event.target.value });
  };

  render() {
    let errorPlaceholder = null;
    if (this.state.error) {
      errorPlaceholder = (
        <p className="alert alert-danger text-center">
          {this.state.errorMessage}
        </p>
      );
    }

    if (!this.state.error && this.state.successMessage) {
      errorPlaceholder = (
        <p className="alert alert-success text-center">
          {this.state.successMessage}
        </p>
      );
    }

    return (
      <div className="card card-container" id="loginbox">
        <Spinner showSpinner={this.state.showSpinner} />
        {errorPlaceholder}
        <form className="form-signin">
          <input
            type="email"
            ref="inputEmail"
            onChange={this.handleEmailChange.bind(this)}
            value={this.state.email}
            className="form-control"
            placeholder="Email address"
            required
          />
          <input
            type="password"
            ref="inputPassword"
            onChange={this.handlePasswordChange.bind(this)}
            value={this.state.password}
            className="form-control"
            placeholder="Password"
            required
          />
          {/* <div id="remember" className="checkbox">
            <label>
              <input type="checkbox" value="remember-me" /> Remember me
            </label>
          </div> */}
          <a
            onClick={this.handleSubmit}
            className="btn btn-lg btn-primary btn-block btn-signin pt-8"
          >
            Sign in
          </a>
        </form>
        <Link to="/forgotpassword" className="forgot-password">
          Forgot the password?
        </Link>
        <Link to="/register" className="pull-right">
          Sign Up
        </Link>
      </div>
    );
  }
}

export default LoginContainer;



// WEBPACK FOOTER //
// ./src/containers/Login/LoginContainer/LoginContainer.js